import 'preact-material-components/style.css';
import './style/index.scss';
import App from './components/app';

export default App;



// WEBPACK FOOTER //
// ./index.js